let Scroll = {
  bind() {
    $('.js-scroll-to').click(function() {
      let sel = $(this).data('selector');
      $('html,body').animate({scrollTop: $(sel).offset().top - 20}, 600);
    });
  },

  init() {
    this.bind();
  },
};

Scroll.init();
